import { RoomDiscount } from '@/entities/map'
import { useMultiScrollState } from '@/shared/lib'

import { FilterChip } from './filter-chip'
import { Filter, useFilter } from '../../model/filter'

const ROOM_DISCOUNTS = [
  {
    title: '장기 계약 할인',
    value: RoomDiscount.LONG_TERM,
  },
  {
    title: '즉시 입주 할인',
    value: RoomDiscount.EARLY,
  },
]

export const RoomDiscounts = () => {
  const { registerScrollElement } = useMultiScrollState<HTMLDivElement>()

  const {
    filter: { roomDiscounts },
    updateFilter,
  } = useFilter()

  const handleRoomDiscountChange = (value: RoomDiscount) => () => {
    updateFilter({ roomDiscounts: value })
  }

  return (
    <div
      className="pr-4 pl-6"
      ref={element => {
        if (element) {
          registerScrollElement(Filter.RoomDiscounts, element)
        }
      }}
    >
      <h3 className="typo-body1 mb-3 font-semibold text-black">할인</h3>
      <ul className="flex flex-wrap gap-2">
        {ROOM_DISCOUNTS.map(({ title, value }) => (
          <li key={value}>
            <FilterChip
              selected={roomDiscounts.includes(value)}
              onClick={handleRoomDiscountChange(value)}
            >
              {title}
            </FilterChip>
          </li>
        ))}
      </ul>
    </div>
  )
}
